/**
 * This file was generated by kysely-codegen.
 * Please do not edit it manually.
 */

import type { ColumnType } from "kysely";

export type BankAccountType = "current" | "savings";

export type DeletionRequesterType = "not_sure" | "owner_manager" | "tenant";

export type DeletionRequestStatus = "completed" | "in_progress" | "pending" | "rejected";

export type DocumentStatus = "expired" | "pending" | "rejected" | "verified";

export type DocumentType = "bank_statement" | "drivers_license" | "employment_letter" | "id_card" | "other" | "passport" | "proof_of_address" | "proof_of_income" | "reference_letter";

export type ExpensePaymentStatus = "cancelled" | "overdue" | "paid" | "partially_paid" | "pending";

export type ExpenseType = "advertising" | "cleaning" | "insurance" | "landscaping" | "legal_fees" | "maintenance" | "management_fee" | "other" | "property_tax" | "repairs" | "salary" | "supplies" | "utilities" | "vendor_payment";

export type FurnishingStatus = "fully_furnished" | "part_furnished" | "unfurnished";

export type Generated<T> = T extends ColumnType<infer S, infer I, infer U>
  ? ColumnType<S, I | undefined, U>
  : ColumnType<T, T | undefined, T>;

export type IdDocumentType = "aadhar" | "driving_license" | "national_id" | "other" | "passport";

export type InstallmentStatus = "bounced" | "cancelled" | "overdue" | "paid" | "pending";

export type InvoiceGenerationMode = "cyclic" | "pro_rata";

export type InvoiceStatus = "cancelled" | "draft" | "overdue" | "paid" | "partial" | "pending";

export type InvoiceType = "electricity" | "late_fee" | "maintenance" | "other" | "rent" | "security_deposit" | "utilities" | "water";

export type Json = JsonValue;

export type JsonArray = JsonValue[];

export type JsonObject = {
  [x: string]: JsonValue | undefined;
};

export type JsonPrimitive = boolean | number | string | null;

export type JsonValue = JsonArray | JsonObject | JsonPrimitive;

export type LeaseStatus = "active" | "expired" | "pending" | "terminated";

export type MaintenanceCostBearer = "landlord" | "shared" | "tenant" | "warranty_claimed";

export type NotificationPriority = "high" | "low" | "medium" | "urgent";

export type NotificationType = "lease_expired" | "lease_expiring" | "maintenance_completed" | "maintenance_created" | "maintenance_updated" | "payment_received" | "rent_due" | "rent_overdue" | "system";

export type Numeric = ColumnType<string, number | string, number | string>;

export type PaymentFrequency = "annually" | "bimonthly" | "biweekly" | "monthly" | "quarterly" | "weekly";

export type PaymentGateway = "manual" | "razorpay" | "stripe";

export type PaymentMethod = "bank_transfer" | "cash" | "check" | "credit_card" | "other" | "upi";

export type PaymentType = "deposit" | "late_fee" | "maintenance" | "other" | "refund" | "rent";

export type PropertyStatus = "active" | "inactive" | "under_maintenance";

export type PurchaseOrderStatus = "approved" | "cancelled" | "completed" | "draft" | "in_progress";

export type PushPlatform = "android" | "ios" | "web";

export type RecurringFrequency = "monthly" | "one_time" | "quarterly" | "weekly" | "yearly";

export type RentPaymentStatus = "completed" | "failed" | "pending" | "processing" | "refunded";

export type RentPaymentTiming = "end_of_month" | "start_of_month";

export type ScheduledRenewalStatus = "applied" | "cancelled" | "scheduled";

export type SecurityEventSeverity = "critical" | "info" | "warning";

export type SecurityEventType = "account_unlock" | "login_failure" | "login_lockout" | "login_success" | "password_change" | "password_reset" | "rate_limit_exceeded" | "session_invalidation" | "suspicious_activity";

export type SubscriptionPlanType = "enterprise" | "free" | "pro";

export type SubscriptionStatus = "active" | "cancelled" | "expired" | "trial";

export type SupplierProfession = "appliance_repair" | "bathroom_fitter" | "carpenter" | "cleaner" | "electrician" | "employee" | "flooring_specialist" | "general_contractor" | "handyman" | "hvac_technician" | "kitchen_fitter" | "landscaper" | "locksmith" | "other" | "painter" | "pest_control" | "plumber" | "roofer" | "security" | "watchman" | "window_installer";

export type TenantPaymentStatus = "approved" | "declined" | "pending_verification";

export type TenantStatus = "current" | "past" | "prospective";

export type TenantType = "company" | "person";

export type Timestamp = ColumnType<Date, Date | string, Date | string>;

export type UnitStatus = "available" | "maintenance" | "occupied" | "reserved";

export type UnitType = "commercial" | "residential";

export type UserRole = "admin" | "finance_officer" | "maintenance_staff" | "owner" | "property_manager" | "tenant" | "user";

export type WorkOrderCategory = "appliance" | "cleaning" | "electrical" | "hvac" | "landscaping" | "other" | "pest_control" | "plumbing" | "structural";

export type WorkOrderPriority = "high" | "low" | "medium" | "urgent";

export type WorkOrderStatus = "cancelled" | "completed" | "in_progress" | "on_hold" | "open" | "pending_approval";

export type WorkOrderVisibility = "landlord_only" | "tenant_visible";

export interface AccountDeletionRequests {
  accountType: Generated<DeletionRequesterType>;
  createdAt: Generated<Timestamp>;
  email: string;
  fullName: string;
  handledAt: Timestamp | null;
  handledBy: number | null;
  handledNotes: string | null;
  id: Generated<number>;
  ipAddress: string | null;
  matchedUserId: number | null;
  reason: string | null;
  status: Generated<DeletionRequestStatus>;
  updatedAt: Generated<Timestamp>;
  userAgent: string | null;
}

export interface EmailTemplates {
  bodyHtml: string;
  bodyText: string | null;
  createdAt: Generated<Timestamp | null>;
  id: Generated<number>;
  isActive: Generated<boolean | null>;
  subject: string;
  templateKey: string;
  templateName: string;
  updatedAt: Generated<Timestamp | null>;
  variables: Generated<Json | null>;
}

export interface ExpenseCategories {
  createdAt: Generated<Timestamp>;
  id: Generated<number>;
  name: string;
  organizationId: number | null;
  parentId: number | null;
}

export interface Expenses {
  amount: Numeric;
  categoryId: number | null;
  createdAt: Generated<Timestamp>;
  currency: Generated<string>;
  description: string;
  dueDate: Timestamp | null;
  expenseDate: Timestamp;
  expenseType: Generated<ExpenseType>;
  id: Generated<number>;
  isRecurring: Generated<boolean>;
  notes: string | null;
  organizationId: number | null;
  otherTypeDescription: string | null;
  parentExpenseId: number | null;
  payableByTenant: Generated<boolean>;
  paymentStatus: Generated<ExpensePaymentStatus>;
  propertyId: number | null;
  purchaseOrderId: number | null;
  recurringEndDate: Timestamp | null;
  recurringFrequency: Generated<RecurringFrequency>;
  supplierId: number | null;
  unitId: number | null;
  updatedAt: Generated<Timestamp>;
}

export interface Invoices {
  amount: Numeric;
  amountPaid: Generated<Numeric | null>;
  createdAt: Generated<Timestamp | null>;
  description: string | null;
  dueDate: Timestamp;
  id: Generated<number>;
  invoiceNumber: string;
  invoiceType: Generated<InvoiceType>;
  issuedDate: Generated<Timestamp | null>;
  lateFee: Generated<Numeric | null>;
  leaseId: number;
  organizationId: number | null;
  otherTypeDescription: string | null;
  status: Generated<InvoiceStatus | null>;
  updatedAt: Generated<Timestamp | null>;
  waivedAt: Timestamp | null;
  waivedBy: number | null;
  workOrderId: number | null;
}

export interface IpRateLimits {
  createdAt: Generated<Timestamp | null>;
  endpoint: string;
  id: Generated<number>;
  ipAddress: string;
  requestCount: Generated<number | null>;
  windowStart: Generated<Timestamp | null>;
}

export interface LeaseInstallments {
  amount: Numeric;
  chequeCopyKey: string | null;
  createdAt: Generated<Timestamp>;
  cycle: Generated<number>;
  dueDate: Timestamp;
  id: Generated<number>;
  installmentNo: number;
  invoiceId: number | null;
  leaseId: number;
  organizationId: number | null;
  paidDate: Timestamp | null;
  referenceNumber: string | null;
  status: Generated<InstallmentStatus>;
  updatedAt: Generated<Timestamp>;
}

export interface LeaseRenewals {
  id: Generated<number>;
  leaseId: number;
  newEndDate: Timestamp;
  newMaintenanceAmount: Numeric | null;
  newRentAmount: Numeric;
  newSecurityDeposit: Numeric | null;
  newStartDate: Timestamp;
  note: string | null;
  previousEndDate: Timestamp;
  previousMaintenanceAmount: Numeric | null;
  previousRentAmount: Numeric;
  previousSecurityDeposit: Numeric | null;
  previousStartDate: Timestamp;
  previousStatus: LeaseStatus | null;
  renewedAt: Generated<Timestamp>;
  renewedBy: number | null;
}

export interface Leases {
  attachments: string | null;
  chequeCount: number | null;
  createdAt: Generated<Timestamp | null>;
  damagesClaimed: Generated<Numeric | null>;
  endDate: Timestamp;
  furnishingStatus: Generated<FurnishingStatus | null>;
  id: Generated<number>;
  inspectionCondition: string | null;
  leaseTemplateId: number | null;
  maintenanceAmount: Generated<Numeric | null>;
  notes: string | null;
  paymentDay: Generated<number | null>;
  paymentFrequency: Generated<PaymentFrequency | null>;
  previousEndDate: Timestamp | null;
  proceedWithCheque: Generated<boolean>;
  propertyHandoverDate: Timestamp | null;
  releasePremise: Generated<boolean | null>;
  reminderDaysBefore: Generated<number | null>;
  reminderEnabled: Generated<boolean | null>;
  renewalCount: Generated<number>;
  renewedAt: Timestamp | null;
  rentAmount: Numeric;
  securityDeposit: Numeric | null;
  startDate: Timestamp;
  status: Generated<LeaseStatus | null>;
  tenantId: number;
  terminatedAt: Timestamp | null;
  terminationEffectiveDate: Timestamp | null;
  terminationImages: string | null;
  terminationReason: string | null;
  unitId: number;
  updatedAt: Generated<Timestamp | null>;
}

export interface LeaseTemplates {
  companyAddress: string | null;
  companyEmail: string | null;
  companyName: string | null;
  companyPhone: string | null;
  content: string | null;
  countryCode: string | null;
  createdAt: Generated<Timestamp | null>;
  customClauses: Generated<Json | null>;
  enabledSections: Generated<Json | null>;
  footerText: string | null;
  headerText: string | null;
  id: Generated<number>;
  includeStampPaper: Generated<boolean | null>;
  isDefault: Generated<boolean | null>;
  logoUrl: string | null;
  name: string;
  organizationId: number;
  sectionOverrides: Generated<Json | null>;
  updatedAt: Generated<Timestamp | null>;
  useCustomContent: Generated<boolean | null>;
}

export interface LoginAttempts {
  attemptedAt: Generated<Timestamp | null>;
  email: string;
  id: Generated<number>;
  ipAddress: string | null;
  success: Generated<boolean | null>;
  userAgent: string | null;
}

export interface NotificationPreferences {
  createdAt: Generated<Timestamp>;
  emailNotificationsEnabled: Generated<boolean>;
  id: Generated<number>;
  leaseExpiryDaysBefore: Generated<number>;
  leaseExpiryEnabled: Generated<boolean>;
  maintenanceUpdatesEnabled: Generated<boolean>;
  paymentNotificationsEnabled: Generated<boolean>;
  pushNotificationsEnabled: Generated<boolean>;
  rentDueDaysBefore: Generated<number>;
  rentDueEnabled: Generated<boolean>;
  systemNotificationsEnabled: Generated<boolean>;
  updatedAt: Generated<Timestamp>;
  userId: number;
}

export interface Notifications {
  createdAt: Generated<Timestamp>;
  id: Generated<number>;
  isRead: Generated<boolean>;
  link: string | null;
  message: string;
  priority: Generated<NotificationPriority>;
  readAt: Timestamp | null;
  relatedEntityId: number | null;
  relatedEntityType: string | null;
  title: string;
  type: NotificationType;
  userId: number;
}

export interface OauthAccounts {
  createdAt: Generated<Timestamp | null>;
  id: Generated<number>;
  provider: string;
  providerEmail: string | null;
  providerUserId: string;
  updatedAt: Generated<Timestamp | null>;
  userId: number;
}

export interface OauthHandoffs {
  consumedAt: Timestamp | null;
  createdAt: Generated<Timestamp>;
  errorCode: string | null;
  errorDetails: string | null;
  errorMessage: string | null;
  expiresAt: Timestamp;
  id: string;
  provider: string;
  state: string;
  tempToken: string | null;
}

export interface OauthStates {
  codeVerifier: string;
  createdAt: Generated<Timestamp | null>;
  expiresAt: Timestamp;
  id: Generated<number>;
  provider: string;
  redirectUrl: string;
  state: string;
}

export interface OrganizationInvitations {
  acceptedAt: Timestamp | null;
  createdAt: Generated<Timestamp | null>;
  email: string;
  expiresAt: Timestamp;
  id: Generated<number>;
  invitedBy: number | null;
  organizationId: number;
  role: Generated<UserRole>;
  token: string;
}

export interface OrganizationMembers {
  id: Generated<number>;
  invitedAt: Timestamp | null;
  invitedBy: number | null;
  isActive: Generated<boolean | null>;
  joinedAt: Generated<Timestamp | null>;
  organizationId: number;
  role: Generated<UserRole>;
  userId: number;
}

export interface Organizations {
  createdAt: Generated<Timestamp | null>;
  id: Generated<number>;
  invoiceSequence: Generated<number>;
  isDemo: Generated<boolean>;
  logoUrl: string | null;
  maintenanceSequence: Generated<number>;
  name: string;
  ownerUserId: number | null;
  primaryColor: Generated<string | null>;
  secondaryColor: Generated<string | null>;
  slug: string;
  updatedAt: Generated<Timestamp | null>;
}

export interface OrganizationSubscriptions {
  cancelledAt: Timestamp | null;
  createdAt: Generated<Timestamp | null>;
  currentPeriodEnd: Timestamp | null;
  currentPeriodStart: Timestamp | null;
  id: Generated<number>;
  organizationId: number;
  planId: number;
  razorpayCustomerId: string | null;
  razorpaySubscriptionId: string | null;
  status: Generated<SubscriptionStatus>;
  trialEndsAt: Timestamp | null;
  updatedAt: Generated<Timestamp | null>;
}

export interface PasswordResetTokens {
  createdAt: Generated<Timestamp | null>;
  expiresAt: Timestamp;
  id: Generated<number>;
  token: string;
  usedAt: Timestamp | null;
  userId: number;
}

export interface Payments {
  amount: Numeric;
  createdAt: Generated<Timestamp | null>;
  id: Generated<number>;
  invoiceId: number;
  notes: string | null;
  paymentDate: Timestamp;
  paymentMethod: PaymentMethod;
  paymentType: Generated<PaymentType | null>;
  referenceNumber: string | null;
}

export interface Permissions {
  category: string;
  createdAt: Generated<Timestamp | null>;
  description: string | null;
  id: Generated<number>;
  isSystem: Generated<boolean>;
  key: string;
  name: string;
  updatedAt: Generated<Timestamp | null>;
}

export interface Properties {
  address: string;
  city: string;
  country: string | null;
  createdAt: Generated<Timestamp | null>;
  currency: Generated<string>;
  id: Generated<number>;
  invoiceGenerationMode: Generated<InvoiceGenerationMode>;
  name: string;
  organizationId: number | null;
  ownerId: number | null;
  propertyType: string;
  rentPaymentTiming: RentPaymentTiming | null;
  state: string | null;
  status: Generated<PropertyStatus | null>;
  totalUnits: Generated<number | null>;
  updatedAt: Generated<Timestamp | null>;
  zipCode: string | null;
}

export interface PurchaseOrderItems {
  createdAt: Generated<Timestamp>;
  description: string;
  id: Generated<number>;
  purchaseOrderId: number;
  quantity: Generated<Numeric>;
  unitPrice: Generated<Numeric>;
}

export interface PurchaseOrders {
  createdAt: Generated<Timestamp>;
  currency: Generated<string>;
  description: string | null;
  id: Generated<number>;
  notes: string | null;
  organizationId: number | null;
  poNumber: string;
  propertyId: number | null;
  status: Generated<PurchaseOrderStatus>;
  supplierId: number | null;
  totalAmount: Generated<Numeric>;
  unitId: number | null;
  updatedAt: Generated<Timestamp>;
}

export interface PushDevices {
  createdAt: Generated<Timestamp>;
  failureCount: Generated<number>;
  id: Generated<number>;
  identity: string;
  lastSuccessAt: Timestamp | null;
  platform: Generated<PushPlatform>;
  subscription: Json;
  updatedAt: Generated<Timestamp>;
  userId: number;
}

export interface RentPaymentTransactions {
  amount: Numeric;
  createdAt: Generated<Timestamp | null>;
  currency: Generated<string | null>;
  gateway: PaymentGateway;
  gatewayOrderId: string | null;
  gatewayPaymentId: string | null;
  gatewaySignature: string | null;
  id: Generated<number>;
  invoiceId: number | null;
  metadata: Generated<Json | null>;
  organizationId: number;
  paymentMethod: string | null;
  status: Generated<RentPaymentStatus>;
  tenantId: number | null;
  updatedAt: Generated<Timestamp | null>;
}

export interface RolePermissions {
  createdAt: Generated<Timestamp | null>;
  granted: Generated<boolean>;
  id: Generated<number>;
  permissionId: number;
  role: UserRole;
  updatedAt: Generated<Timestamp | null>;
}

export interface ScheduledLeaseRenewals {
  appliedAt: Timestamp | null;
  cancelledAt: Timestamp | null;
  createdAt: Generated<Timestamp>;
  createdBy: number | null;
  furnishingStatus: FurnishingStatus | null;
  id: Generated<number>;
  installments: Json | null;
  leaseId: number;
  maintenanceAmount: Numeric | null;
  newEndDate: Timestamp;
  newStartDate: Timestamp;
  note: string | null;
  organizationId: number;
  paymentDay: number | null;
  paymentFrequency: PaymentFrequency | null;
  reminderDaysBefore: number | null;
  reminderEnabled: boolean | null;
  rentAmount: Numeric;
  securityDeposit: Numeric | null;
  status: Generated<ScheduledRenewalStatus>;
  updatedAt: Generated<Timestamp>;
}

export interface SecurityActivityLogs {
  createdAt: Generated<Timestamp | null>;
  email: string | null;
  eventType: SecurityEventType;
  id: Generated<number>;
  ipAddress: string | null;
  metadata: Generated<Json | null>;
  severity: Generated<SecurityEventSeverity | null>;
  userAgent: string | null;
  userId: number | null;
}

export interface Sessions {
  activeTenantId: number | null;
  createdAt: Generated<Timestamp | null>;
  expiresAt: Timestamp;
  id: string;
  lastAccessed: Generated<Timestamp | null>;
  userId: number;
}

export interface SmsTemplates {
  body: string;
  createdAt: Generated<Timestamp | null>;
  id: Generated<number>;
  isActive: Generated<boolean | null>;
  templateKey: string;
  templateName: string;
  updatedAt: Generated<Timestamp | null>;
  variables: Generated<Json | null>;
}

export interface SubscriptionPlans {
  createdAt: Generated<Timestamp | null>;
  features: Generated<Json | null>;
  id: Generated<number>;
  isActive: Generated<boolean | null>;
  maxProperties: number | null;
  maxUnitsPerProperty: number | null;
  maxUsers: number | null;
  name: string;
  planType: SubscriptionPlanType;
  priceMonthly: Generated<Numeric | null>;
  priceYearly: Generated<Numeric | null>;
  trialDays: Generated<number | null>;
}

export interface Suppliers {
  bankAccountNumber: string | null;
  bankName: string | null;
  bankRoutingNumber: string | null;
  createdAt: Generated<Timestamp>;
  email: string | null;
  id: Generated<number>;
  mobile: string | null;
  name: string;
  notes: string | null;
  organizationId: number | null;
  otherProfessionDescription: string | null;
  phone: string | null;
  profession: Generated<SupplierProfession>;
  updatedAt: Generated<Timestamp>;
  website: string | null;
}

export interface SystemSettings {
  description: string | null;
  id: Generated<number>;
  organizationId: number | null;
  settingCategory: string;
  settingKey: string;
  settingValue: Generated<Json>;
  updatedAt: Generated<Timestamp | null>;
  updatedBy: number | null;
}

export interface TenantDocuments {
  createdAt: Generated<Timestamp | null>;
  documentName: string;
  documentType: DocumentType;
  expiryDate: Timestamp | null;
  fileData: string;
  fileKey: string | null;
  fileMimeType: string;
  fileSize: number;
  id: Generated<number>;
  notes: string | null;
  rejectionReason: string | null;
  status: Generated<DocumentStatus>;
  tenantId: number;
  updatedAt: Generated<Timestamp | null>;
  verifiedAt: Timestamp | null;
  verifiedBy: number | null;
}

export interface TenantPaymentSubmissions {
  amount: Numeric;
  createdAt: Generated<Timestamp | null>;
  id: Generated<number>;
  invoiceId: number;
  notes: string | null;
  paymentDate: Timestamp;
  paymentMethod: string;
  receiptData: string | null;
  receiptFilename: string | null;
  receiptKey: string | null;
  receiptMimeType: string | null;
  referenceNumber: string | null;
  rejectionReason: string | null;
  reviewedAt: Timestamp | null;
  reviewedBy: number | null;
  status: Generated<TenantPaymentStatus>;
  submittedBy: number;
  tenantId: number;
  updatedAt: Generated<Timestamp | null>;
}

export interface Tenants {
  accountDeleted: Generated<boolean>;
  accountDeletedAt: Timestamp | null;
  bankAccountHolderName: string | null;
  bankAccountNumber: string | null;
  bankAccountType: BankAccountType | null;
  bankBranch: string | null;
  bankIfscCode: string | null;
  bankName: string | null;
  bankRoutingNumber: string | null;
  businessAddress: string | null;
  companyName: string | null;
  contactPersonEmail: string | null;
  contactPersonName: string | null;
  contactPersonPhone: string | null;
  createdAt: Generated<Timestamp | null>;
  currentAddress: string | null;
  dateOfBirth: Timestamp | null;
  email: string | null;
  emergencyContactName: string | null;
  emergencyContactPhone: string | null;
  id: Generated<number>;
  idNumber: string | null;
  idType: IdDocumentType | null;
  moveInDate: Timestamp | null;
  name: string | null;
  notes: string | null;
  organizationId: number | null;
  phone: string | null;
  portalEnabled: Generated<boolean | null>;
  portalInvitationExpiresAt: Timestamp | null;
  portalInvitationToken: string | null;
  registrationNumber: string | null;
  taxNumber: string | null;
  tenantStatus: Generated<TenantStatus | null>;
  tenantType: Generated<TenantType | null>;
  updatedAt: Generated<Timestamp | null>;
  upiId: string | null;
  userId: number | null;
}

export interface Units {
  bathrooms: Generated<Numeric | null>;
  bedrooms: Generated<number | null>;
  createdAt: Generated<Timestamp | null>;
  electricityMeterNumber: Generated<string | null>;
  floorNo: number | null;
  gasMeterNumber: Generated<string | null>;
  id: Generated<number>;
  meterNumber: string | null;
  propertyId: number;
  rentAmount: Numeric;
  securityDeposit: Numeric | null;
  squareFeet: number | null;
  status: Generated<UnitStatus | null>;
  unitNumber: string;
  unitType: Generated<UnitType | null>;
  updatedAt: Generated<Timestamp | null>;
}

export interface UserPasswords {
  createdAt: Generated<Timestamp | null>;
  id: Generated<number>;
  passwordHash: string;
  userId: number;
}

export interface Users {
  avatarUrl: string | null;
  createdAt: Generated<Timestamp | null>;
  deletedAt: Timestamp | null;
  deletionPurgeAt: Timestamp | null;
  deletionRequestedAt: Timestamp | null;
  displayName: string;
  email: string;
  id: Generated<number>;
  phone: string | null;
  reportingCurrency: Generated<string | null>;
  role: Generated<UserRole>;
  selectedCountry: Generated<string | null>;
  updatedAt: Generated<Timestamp | null>;
}

export interface WorkOrders {
  actualCost: Numeric | null;
  assignedTo: string | null;
  category: WorkOrderCategory;
  closedAt: Timestamp | null;
  closedBy: number | null;
  completedDate: Timestamp | null;
  costBearer: MaintenanceCostBearer | null;
  createdAt: Generated<Timestamp | null>;
  description: string | null;
  dueDate: Timestamp | null;
  estimatedCost: Numeric | null;
  extraCost: Numeric | null;
  extraCostBearer: MaintenanceCostBearer | null;
  extraCostTenantCharge: Numeric | null;
  id: Generated<number>;
  images: string | null;
  landlordPaid: Generated<boolean>;
  notes: string | null;
  organizationId: number | null;
  otherCategoryDescription: string | null;
  paymentDueDate: Timestamp | null;
  paymentPaidDate: Timestamp | null;
  priority: Generated<WorkOrderPriority | null>;
  rejectionReason: string | null;
  reportedBy: number | null;
  requestId: string | null;
  status: Generated<WorkOrderStatus | null>;
  tenantChargeAmount: Numeric | null;
  title: string;
  unitId: number;
  updatedAt: Generated<Timestamp | null>;
  vendorName: string | null;
  vendorPhone: string | null;
  visibility: Generated<WorkOrderVisibility | null>;
  warrantyMonths: Generated<number>;
  warrantyStartDate: Timestamp | null;
}

export interface ZakatCycles {
  completedAt: Generated<Timestamp>;
  completedBy: number | null;
  createdAt: Generated<Timestamp>;
  currency: Generated<string>;
  endDate: Timestamp;
  id: Generated<number>;
  netProfit: Generated<Numeric>;
  organizationId: number;
  startDate: Timestamp;
  totalDeposits: Generated<Numeric>;
  totalExpenses: Generated<Numeric>;
  totalIncome: Generated<Numeric>;
  yearType: string;
  zakatDue: Generated<Numeric>;
}

export interface DB {
  accountDeletionRequests: AccountDeletionRequests;
  emailTemplates: EmailTemplates;
  expenseCategories: ExpenseCategories;
  expenses: Expenses;
  invoices: Invoices;
  ipRateLimits: IpRateLimits;
  leaseInstallments: LeaseInstallments;
  leaseRenewals: LeaseRenewals;
  leases: Leases;
  leaseTemplates: LeaseTemplates;
  loginAttempts: LoginAttempts;
  notificationPreferences: NotificationPreferences;
  notifications: Notifications;
  oauthAccounts: OauthAccounts;
  oauthHandoffs: OauthHandoffs;
  oauthStates: OauthStates;
  organizationInvitations: OrganizationInvitations;
  organizationMembers: OrganizationMembers;
  organizations: Organizations;
  organizationSubscriptions: OrganizationSubscriptions;
  passwordResetTokens: PasswordResetTokens;
  payments: Payments;
  permissions: Permissions;
  properties: Properties;
  purchaseOrderItems: PurchaseOrderItems;
  purchaseOrders: PurchaseOrders;
  pushDevices: PushDevices;
  rentPaymentTransactions: RentPaymentTransactions;
  rolePermissions: RolePermissions;
  scheduledLeaseRenewals: ScheduledLeaseRenewals;
  securityActivityLogs: SecurityActivityLogs;
  sessions: Sessions;
  smsTemplates: SmsTemplates;
  subscriptionPlans: SubscriptionPlans;
  suppliers: Suppliers;
  systemSettings: SystemSettings;
  tenantDocuments: TenantDocuments;
  tenantPaymentSubmissions: TenantPaymentSubmissions;
  tenants: Tenants;
  units: Units;
  userPasswords: UserPasswords;
  users: Users;
  workOrders: WorkOrders;
  zakatCycles: ZakatCycles;
}


// Use these for zod schema enums or other purposes, since the kysely enums are just types
export const BankAccountTypeArrayValues: [BankAccountType, ...BankAccountType[]] = ["current","savings"];
export const DocumentStatusArrayValues: [DocumentStatus, ...DocumentStatus[]] = ["expired","pending","rejected","verified"];
export const DocumentTypeArrayValues: [DocumentType, ...DocumentType[]] = ["bank_statement","drivers_license","employment_letter","id_card","other","passport","proof_of_address","proof_of_income","reference_letter"];
export const ExpensePaymentStatusArrayValues: [ExpensePaymentStatus, ...ExpensePaymentStatus[]] = ["cancelled","overdue","paid","partially_paid","pending"];
export const ExpenseTypeArrayValues: [ExpenseType, ...ExpenseType[]] = ["advertising","cleaning","insurance","landscaping","legal_fees","maintenance","management_fee","other","property_tax","repairs","salary","supplies","utilities","vendor_payment"];
export const FurnishingStatusArrayValues: [FurnishingStatus, ...FurnishingStatus[]] = ["fully_furnished","part_furnished","unfurnished"];
export const IdDocumentTypeArrayValues: [IdDocumentType, ...IdDocumentType[]] = ["aadhar","driving_license","national_id","other","passport"];
export const InvoiceStatusArrayValues: [InvoiceStatus, ...InvoiceStatus[]] = ["cancelled","draft","overdue","paid","partial","pending"];
export const InvoiceTypeArrayValues: [InvoiceType, ...InvoiceType[]] = ["electricity","late_fee","maintenance","other","rent","security_deposit","utilities","water"];
export const LeaseStatusArrayValues: [LeaseStatus, ...LeaseStatus[]] = ["active","expired","pending","terminated"];
export const NotificationPriorityArrayValues: [NotificationPriority, ...NotificationPriority[]] = ["high","low","medium","urgent"];
export const NotificationTypeArrayValues: [NotificationType, ...NotificationType[]] = ["lease_expired","lease_expiring","maintenance_completed","maintenance_created","maintenance_updated","payment_received","rent_due","rent_overdue","system"];
export const PaymentFrequencyArrayValues: [PaymentFrequency, ...PaymentFrequency[]] = ["annually","bimonthly","biweekly","monthly","quarterly","weekly"];
export const PaymentGatewayArrayValues: [PaymentGateway, ...PaymentGateway[]] = ["manual","razorpay","stripe"];
export const PaymentMethodArrayValues: [PaymentMethod, ...PaymentMethod[]] = ["bank_transfer","cash","check","credit_card","other","upi"];
export const PaymentTypeArrayValues: [PaymentType, ...PaymentType[]] = ["deposit","late_fee","maintenance","other","refund","rent"];
export const PropertyStatusArrayValues: [PropertyStatus, ...PropertyStatus[]] = ["active","inactive","under_maintenance"];
export const PurchaseOrderStatusArrayValues: [PurchaseOrderStatus, ...PurchaseOrderStatus[]] = ["approved","cancelled","completed","draft","in_progress"];
export const RecurringFrequencyArrayValues: [RecurringFrequency, ...RecurringFrequency[]] = ["monthly","one_time","quarterly","weekly","yearly"];
export const RentPaymentStatusArrayValues: [RentPaymentStatus, ...RentPaymentStatus[]] = ["completed","failed","pending","processing","refunded"];
export const SecurityEventSeverityArrayValues: [SecurityEventSeverity, ...SecurityEventSeverity[]] = ["critical","info","warning"];
export const SecurityEventTypeArrayValues: [SecurityEventType, ...SecurityEventType[]] = ["account_unlock","login_failure","login_lockout","login_success","password_change","password_reset","rate_limit_exceeded","session_invalidation","suspicious_activity"];
export const SubscriptionPlanTypeArrayValues: [SubscriptionPlanType, ...SubscriptionPlanType[]] = ["enterprise","free","pro"];
export const SubscriptionStatusArrayValues: [SubscriptionStatus, ...SubscriptionStatus[]] = ["active","cancelled","expired","trial"];
export const SupplierProfessionArrayValues: [SupplierProfession, ...SupplierProfession[]] = ["appliance_repair","bathroom_fitter","carpenter","cleaner","electrician","employee","flooring_specialist","general_contractor","handyman","hvac_technician","kitchen_fitter","landscaper","locksmith","other","painter","pest_control","plumber","roofer","security","watchman","window_installer"];
export const TenantStatusArrayValues: [TenantStatus, ...TenantStatus[]] = ["current","past","prospective"];
export const TenantTypeArrayValues: [TenantType, ...TenantType[]] = ["company","person"];
export const UnitStatusArrayValues: [UnitStatus, ...UnitStatus[]] = ["available","maintenance","occupied","reserved"];
export const UnitTypeArrayValues: [UnitType, ...UnitType[]] = ["commercial","residential"];
export const UserRoleArrayValues: [UserRole, ...UserRole[]] = ["admin","finance_officer","maintenance_staff","owner","property_manager","tenant","user"];
export const WorkOrderCategoryArrayValues: [WorkOrderCategory, ...WorkOrderCategory[]] = ["appliance","cleaning","electrical","hvac","landscaping","other","pest_control","plumbing","structural"];
export const WorkOrderPriorityArrayValues: [WorkOrderPriority, ...WorkOrderPriority[]] = ["high","low","medium","urgent"];
export const WorkOrderStatusArrayValues: [WorkOrderStatus, ...WorkOrderStatus[]] = ["cancelled","completed","in_progress","on_hold","open","pending_approval"];
export const WorkOrderVisibilityArrayValues: [WorkOrderVisibility, ...WorkOrderVisibility[]] = ["landlord_only","tenant_visible"];
export const RentPaymentTimingArrayValues: [RentPaymentTiming, ...RentPaymentTiming[]] = ["end_of_month","start_of_month"];
export const TenantPaymentStatusArrayValues: [TenantPaymentStatus, ...TenantPaymentStatus[]] = ["approved","declined","pending_verification"];
export const InvoiceGenerationModeArrayValues: [InvoiceGenerationMode, ...InvoiceGenerationMode[]] = ["cyclic","pro_rata"];
export const MaintenanceCostBearerArrayValues: [MaintenanceCostBearer, ...MaintenanceCostBearer[]] = ["landlord","shared","tenant","warranty_claimed"];
export const PushPlatformArrayValues: [PushPlatform, ...PushPlatform[]] = ["android","ios","web"];
export const DeletionRequestStatusArrayValues: [DeletionRequestStatus, ...DeletionRequestStatus[]] = ["completed","in_progress","pending","rejected"];
export const DeletionRequesterTypeArrayValues: [DeletionRequesterType, ...DeletionRequesterType[]] = ["not_sure","owner_manager","tenant"];
export const InstallmentStatusArrayValues: [InstallmentStatus, ...InstallmentStatus[]] = ["bounced","cancelled","overdue","paid","pending"];
export const ScheduledRenewalStatusArrayValues: [ScheduledRenewalStatus, ...ScheduledRenewalStatus[]] = ["applied","cancelled","scheduled"];
// Table/column names whose snake_case spelling kysely's default CamelCasePlugin
// cannot recover from the camelCase name used in code (an underscore directly
// before a digit, e.g. reminder_48h_sent ⇄ reminder48hSent). The db helper's
// CamelCasePlugin subclass consults this map so those identifiers work in
// queries. Regenerated on every schema pull.
export const kyselyIdentifierOverrides: Record<string, string> = {};

// Note: kysely maps the table/column/enum names from snake_case to camelCase and PascalCase. When running SQL statements, make sure to use snake_case, but TypeScript code should use camelCase or PascalCase.